import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useState } from 'react';
import store from '../../state/store';
import ENVIRONMENT_VARIABLES from '../../utils/environmentVariables';
import Logger from '../../lib/analytics/logger';
import LoginInterface from '../../api/LoginInterface';
import Utils from '../../utils';
import audio from '../../utils/audio';
import AsyncStorage from '@react-native-community/async-storage';
import { useFormik } from 'formik';
import { initialValues, validationSchema } from './signup-validations';
import { usePostSignupMutation, usePostSSOSignupMutation } from '../../state/query/signup';
import { EVENT_TYPES } from '../../lib/analytics/constants';
import { ERROR_TYPES } from '../../utils/authFlow/constants';
import { getText, TEXT_KEY } from '../../utils/localization';
import useNotification from '../../hooks/useNotification';

var useSignup = function useSignup() {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      signUpInProgress = _useState2[0],
      changeSignUpStatus = _useState2[1];

  var _useState3 = useState(ENVIRONMENT_VARIABLES.SSO_ENABLED === 'true' ? 'unverified' : ''),
      _useState4 = _slicedToArray(_useState3, 2),
      userStatus = _useState4[0],
      setUserStatus = _useState4[1];

  var _usePostSignupMutatio = usePostSignupMutation(),
      _usePostSignupMutatio2 = _slicedToArray(_usePostSignupMutatio, 2),
      postSignup = _usePostSignupMutatio2[0],
      _usePostSignupMutatio3 = _usePostSignupMutatio2[1],
      data = _usePostSignupMutatio3.data,
      isLoading = _usePostSignupMutatio3.isLoading;

  var _usePostSSOSignupMuta = usePostSSOSignupMutation(),
      _usePostSSOSignupMuta2 = _slicedToArray(_usePostSSOSignupMuta, 1),
      postSSOSignup = _usePostSSOSignupMuta2[0];

  var _useNotification = useNotification(),
      addNotification = _useNotification.addNotification;

  var onSubmitHandler = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var firstName, lastName, email, password, emailOptIn, isDuplicated, signUpMethod, affId;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              firstName = _ref.firstName, lastName = _ref.lastName, email = _ref.email, password = _ref.password, emailOptIn = _ref.emailOptIn;
              changeSignUpStatus(true);

              if (userStatus) {
                _context.next = 10;
                break;
              }

              _context.next = 5;
              return duplicateCheckHandler(email);

            case 5:
              isDuplicated = _context.sent;

              if (!isDuplicated) {
                _context.next = 10;
                break;
              }

              formikValidation.setStatus({
                message: getText(TEXT_KEY.EMAIL_ALREADY_EXISTS)
              });
              changeSignUpStatus(false);
              return _context.abrupt("return");

            case 10:
              setUserStatus('new');
              signUpMethod = ENVIRONMENT_VARIABLES.SSO_ENABLED === 'true' ? postSSOSignup : postSignup;

              if (!(Utils.getPlatform() === 'web')) {
                _context.next = 16;
                break;
              }

              _context.t0 = store.getState().playerInfo.aff_id;
              _context.next = 19;
              break;

            case 16:
              _context.next = 18;
              return AsyncStorage.getItem('aff_id');

            case 18:
              _context.t0 = _context.sent;

            case 19:
              affId = _context.t0;
              signUpMethod(_objectSpread({
                userStatus: 'new',
                emailOptIn: emailOptIn ? 'yes' : 'no',
                firstname: firstName,
                lastname: lastName,
                email: email,
                password: password
              }, affId && {
                aff_id: affId
              })).unwrap().then(function (result) {
                changeSignUpStatus(false);
                formikValidation.setStatus(result);
                Logger.sendEvent(EVENT_TYPES.REGISTRATION_COMPLETE, {
                  type: 'email'
                });
              }).catch(function (error) {
                var _error$data, _error$data2, _error$data3;

                changeSignUpStatus(false);
                error && formikValidation.setStatus((_error$data = error.data) === null || _error$data === void 0 ? void 0 : _error$data.message);
                ((_error$data2 = error.data) === null || _error$data2 === void 0 ? void 0 : _error$data2.error_code) === ERROR_TYPES.GEO_BLOCK && addNotification({
                  title: getText(TEXT_KEY.TRY_AGAIN),
                  message: (_error$data3 = error.data) === null || _error$data3 === void 0 ? void 0 : _error$data3.message,
                  button: getText(TEXT_KEY.OK)
                });
              });

            case 21:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onSubmitHandler(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var duplicateCheckHandler = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(email) {
      var emailExists;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return LoginInterface.checkIfEmailExists(email);

            case 3:
              emailExists = _context2.sent;
              return _context2.abrupt("return", emailExists);

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](0);
              formikValidation.setStatus(_context2.t0.message);

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 7]]);
    }));

    return function duplicateCheckHandler(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  var handleCheckBoxToggle = function handleCheckBoxToggle(field, currentValue) {
    audio.onClick();
    formikValidation.setFieldValue(field, !currentValue);
  };

  var getStatusMessage = function getStatusMessage() {
    var _formikValidation$sta, _formikValidation$sta2;

    return Object.values(formikValidation.errors)[0] || ((_formikValidation$sta = formikValidation.status) === null || _formikValidation$sta === void 0 ? void 0 : _formikValidation$sta.message) || ((_formikValidation$sta2 = formikValidation.status) === null || _formikValidation$sta2 === void 0 ? void 0 : _formikValidation$sta2.error);
  };

  var formikValidation = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: onSubmitHandler,
    isInitialValid: false,
    validateOnChange: false,
    validateOnBlur: false
  });
  return {
    formikValidation: formikValidation,
    handleCheckBoxToggle: handleCheckBoxToggle,
    getStatusMessage: getStatusMessage,
    postSignupData: data,
    isLoading: isLoading || signUpInProgress
  };
};

export default useSignup;